var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4342B",
    fillRule: "evenodd",
    d: "M6.6 6.207a.43.43 0 0 1 .42-.129l9.043 2.214a.4.4 0 0 1 .15.07l1.84 1.342a.43.43 0 0 1 .101.587l-6.33 9.262a.428.428 0 0 1-.758-.099L6.514 6.638a.43.43 0 0 1 .086-.43M8.092 8.52l3.16 8.897l.52-4.61zm4.526 4.435l-.528 4.691l4.47-6.541zm4.345-2.986l-2.881 1.352l1.931-2.044zm-1.82-1.02l-7.03-1.72l4.122 4.8z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrx);
export default __webpack_public_path__ + "static/media/trx.020bef4c163a4dbdd60aef4597936659.svg";
export { ForwardRef as ReactComponent };